
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Page } from 'tesseract.js';
import { PaginatedResponse } from '../interfaces/stockPaginatedResponse';
import { Stock } from '../interfaces/stock';
import { Stockitem } from '../interfaces/stockitem';

@Injectable({
  providedIn: 'root',
})
export class AdvancedStocksService {
  constructor(private http: HttpClient) { }

  getStocksByWarehousePetCategory(
    warehouseId: number,
    page: number = 1,
    perPage: number = 10,
    pet?: any,
    categoryId?: number,
  ): Observable<any> {
    let params: any = { warehouse_id: warehouseId, page, per_page: perPage };

    if (pet !== undefined && pet !== null) {
      params.pet = pet;
    }
    if (categoryId !== undefined && categoryId !== null) {
      params.category_id = categoryId;
    }

    return this.http.get(`${environment.Server_URL}/stocks/filter`, { params });
  }

  // ✅ فلترة حسب warehouse + brand_id
  getStocksByWarehouseAndBrand(
    warehouseId: number,
    brandId?: number,
    page: number = 1,
    perPage: number = 10,
    categoryId?: string
  ): Observable<any> {
    let params: any = { warehouse_id: warehouseId, page, per_page: perPage };

    if (brandId !== undefined && brandId !== null) {
      params.brand_id = brandId;
    }
    if (categoryId !== undefined && categoryId !== null) {
      params.category_id = categoryId;
    }

    return this.http.get(`${environment.Server_URL}/stocks/filter-by-warehouse-brand`, { params });
  } advancedStocks(
    warehouseId: number,
    page: number = 1,
    perPage: number = 10,
    options?: {
      pet?: number;
      categoryId?: number;
      brandId?: number;
      minPrice?: number;
      maxPrice?: number;
    }
  ): Observable<PaginatedResponse<Stockitem>> {
    let params: any = { warehouse_id: warehouseId, page, per_page: perPage };

    if (options) {
      if (options.pet !== undefined && options.pet !== null) {
        params.pet = options.pet;
      }
      if (options.categoryId !== undefined && options.categoryId !== null) {
        params.category_id = options.categoryId;
      }
      if (options.brandId !== undefined && options.brandId !== null) {
        params.brand_id = options.brandId;
      }
      if (options.minPrice !== undefined && options.minPrice !== null) {
        params.min_price = options.minPrice;
      }
      if (options.maxPrice !== undefined && options.maxPrice !== null) {
        params.max_price = options.maxPrice;
      }
    }

    return this.http.get<PaginatedResponse<Stockitem>>(
      `${environment.Server_URL}/stocks/advancedfilter`,
      { params }
    );
  }
  getStocksWithPriceDiff(
    warehouseId: number,
    page: number = 1,
    perPage: number = 10
  ): Observable<PaginatedResponse<Stockitem>> {
    let params: any = { warehouse_id: warehouseId, page, per_page: perPage };

    return this.http.get<PaginatedResponse<Stockitem>>(
      `${environment.Server_URL}/stocks/with-price-diff`,
      { params }
    );
  }
  getStocksByWarehouse(warehouseId: number, page: number, perPage: number): Observable<any> {
    return this.http.get(
      `${environment.Server_URL}/stocks/warehouse?warehouse_id=${warehouseId}&page=${page}&per_page=${perPage}`
    );
  }
  getWarehouseOneByMaxPriceDiff(
    page: number = 1,
    perPage: number = 10
  ): Observable<PaginatedResponse<Stockitem>> {

    const params: any = {
      page,
      per_page: perPage
    };

    return this.http.get<PaginatedResponse<Stockitem>>(
      `${environment.Server_URL}/stocks/warehouse-one/max-price-diff`,
      { params }
    );
  }
  // 🔥 Daily Offer (Backend-driven)
  getDailyOffer(): Observable<any> {
    return this.http.get(
      `${environment.Server_URL}/daily-offer`
    );
  }
  getDailyOffers(
    warehouseId?: number,
    page: number = 1,

  ): Observable<any> {

    let params: any = { page };

    if (warehouseId) {
      params.warehouse_id = warehouseId;
    }

    return this.http.get(
      `${environment.Server_URL}/stocks/daily-offers`,
      { params }
    );
  }

  getTopRatedStocks(
    warehouseId?: number,
    page: number = 1,
    perPage: number = 10
  ): Observable<PaginatedResponse<Stockitem>> {

    let params: any = { page, per_page: perPage };

    if (warehouseId) {
      params.warehouse_id = warehouseId;
    }

    return this.http.get<PaginatedResponse<Stockitem>>(
      `${environment.Server_URL}/stocks/top-rated`,
      { params }
    );
  }

}
